module.exports = __webpack_public_path__ + "img/ent_statement.9a36bdbb.png";